import { render, staticRenderFns } from "./preregistrov2.vue?vue&type=template&id=73839fc6&scoped=true"
import script from "./preregistrov2.vue?vue&type=script&lang=js"
export * from "./preregistrov2.vue?vue&type=script&lang=js"
import style0 from "./preregistrov2.vue?vue&type=style&index=0&id=73839fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73839fc6",
  null
  
)

export default component.exports